// extracted by mini-css-extract-plugin
module.exports = {"TabSwriper":"TabSwriper_TabSwriper___l5Kb"};